export default __webpack_public_path__ + "static/amazonFires10-f7814449206f3f443c6fe16501f87d88.gif";